import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../i18n';
import SmartEstimator from '../components/SmartEstimator';
import '../PortfolioV2.css';

const pageCopy = {
  fr: { back: 'Retour au portfolio', note: 'Vous pouvez recommencer autant de fois que nécessaire. Aucune coordonnée n’est demandée pour voir le résultat.' },
  en: { back: 'Back to portfolio', note: 'You can restart as often as needed. No contact details are required to see the result.' },
  pt: { back: 'Voltar ao portfólio', note: 'Você pode recomeçar quando quiser. Nenhum contato é necessário para ver o resultado.' },
};

export default function EstimatorPage() {
  const { lang } = useLang();
  const t = pageCopy[lang] || pageCopy.fr;

  useEffect(() => {
    document.title = lang === 'fr' ? 'Estimer mon projet web | Alioune Seck' : 'Estimate my web project | Alioune Seck';
    document.querySelector('meta[name="description"]')?.setAttribute('content', lang === 'fr'
      ? 'Estimez le budget et le délai de votre site, réservation, e-commerce, outil métier ou reprise de projet en quelques questions.'
      : 'Estimate the budget and timeline for your website, booking, e-commerce, business tool or existing project.');
  }, [lang]);

  return (
    <div className="estimator-page-v2">
      <header className="estimator-page-header">
        <Link to="/" className="v2-brand">
          <span className="v2-brand-symbol">AS</span>
          <span><strong>Alioune Seck</strong><small>Développeur web freelance</small></span>
        </Link>
        <Link to="/" className="v2-secondary">← {t.back}</Link>
      </header>
      <main>
        <SmartEstimator />
        <p className="estimator-privacy-note">{t.note}</p>
      </main>
    </div>
  );
}
